import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { RequestAgingDto } from '../types';
import { useChartColors } from '../hooks/useChartColors';

interface RequestAgingChartProps {
  data: RequestAgingDto[];
}

export function RequestAgingChart({ data }: RequestAgingChartProps) {
  const c = useChartColors();
  // 4 DISTINCT severity hues (fresh -> critical). Kept as a categorical ramp:
  // solid bars read on light & dark card surfaces, and there's no 4-step
  // semantic token ramp (green -> amber -> orange -> red).
  const COLORS = ['hsl(142 71% 40%)', 'hsl(45 93% 47%)', 'hsl(25 90% 53%)', 'hsl(0 84% 55%)'];
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Request Aging</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[200px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} layout="vertical" margin={{ left: 20, right: 20 }}>
              <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke={c.border} />
              <XAxis type="number" allowDecimals={false} tick={{ fontSize: 12, fill: c.muted }} stroke={c.border} />
              <YAxis type="category" dataKey="bucket" width={80} tick={{ fontSize: 12, fill: c.muted }} stroke={c.border} />
              <Tooltip
                cursor={{ fill: c.muted, fillOpacity: 0.1 }}
                formatter={(value) => [`${value} requests`, 'Count']}
                contentStyle={{ fontSize: 12, backgroundColor: c.card, border: `1px solid ${c.border}`, borderRadius: 6, color: c.foreground }}
                labelStyle={{ color: c.foreground }}
                itemStyle={{ color: c.foreground }}
              />
              <Bar dataKey="count" radius={[0, 4, 4, 0]}>
                {data.map((_, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
